var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "top" } },
    [
      _c("headNav", { attrs: { gray: _vm.gray } }),
      _vm._v(" "),
      _c("div", { staticClass: "innerWrapper" }, [
        _c("div", { staticClass: "home" }),
        _vm._v(" "),
        _c("h1", [_vm._v("Complete")]),
        _vm._v(" "),
        _c(
          "h4",
          { staticStyle: { padding: "0 .26rem", "box-sizing": "border-box" } },
          [
            _vm._v(
              "\n      You have Successfuly reserved the following property for your client.\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticStyle: { padding: "0 .26rem", "box-sizing": "border-box" } },
          [
            _vm._v(
              "\n      We will shortly send through an email containing the contract for this\n      property and a Unifi employee will be in touch with you.\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "info" }, [
          _c("div", { staticClass: "top" }, [
            _vm._v("$" + _vm._s(_vm.item.price))
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v(_vm._s(_vm.item.proertyType))]),
          _vm._v(" "),
          _c("h3", [
            _vm.item.apt
              ? _c("i", { staticStyle: { "font-style": "normal" } }, [
                  _vm._v(_vm._s(_vm.item.apt) + " / ")
                ])
              : _vm._e(),
            _vm._v(
              _vm._s(_vm.item.address) +
                " " +
                _vm._s(_vm.item.suburb) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("h6", [
            _vm._v(_vm._s(_vm.item.state) + " " + _vm._s(_vm.item.postcode))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dtl" }, [
            _c("p", [
              _c("span", [_vm._v("Estimated commencement")]),
              _c("span", [_vm._v(_vm._s(_vm.item.estimatedCommenceMent))])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", [_vm._v("Estimated completion")]),
              _c("span", [_vm._v(_vm._s(_vm.item.estimatedCompletion))])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._m(0),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-top": ".05rem" } }, [
                _vm._v(
                  "\n            $" + _vm._s(_vm.item.rental) + "\n            "
                ),
                _vm.item.maxRental &&
                _vm.item.maxRental !== "" &&
                _vm.item.maxRental !== 0 &&
                _vm.item.maxRental !== "0"
                  ? _c(
                      "i",
                      {
                        staticStyle: {
                          "font-style": "normal",
                          display: "block",
                          "line-height": ".2rem",
                          float: "none",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("\n              -\n            ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.maxRental &&
                _vm.item.maxRental !== "" &&
                _vm.item.maxRental !== 0 &&
                _vm.item.maxRental !== "0"
                  ? _c(
                      "i",
                      {
                        staticStyle: {
                          "font-style": "normal",
                          display: "block",
                          float: "none",
                          "text-align": "left"
                        }
                      },
                      [_vm._v("$" + _vm._s(_vm.item.maxRental))]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm.item.proertyType === "House & Land"
              ? _c("p", [
                  _c("span", [_vm._v("Land price")]),
                  _c("span", [_vm._v("$" + _vm._s(_vm.item.landPrice))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.proertyType === "House & Land"
              ? _c("p", [
                  _c("span", [_vm._v("Build price")]),
                  _c("span", [_vm._v("$" + _vm._s(_vm.item.buildPrice))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _c("span", [_vm._v("Rental yield")]),
              _c("span", [_vm._v(_vm._s(_vm.item.rentalYield) + "%")])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", [_vm._v("Incentives")]),
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.item.incentives) }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("button", { on: { click: _vm.back } }, [_vm._v("Done")])
      ]),
      _vm._v(" "),
      _c("foot-nav")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Estimated rental"),
      _c("br"),
      _vm._v("(per week)")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ba612c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba612c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/details/property/complete.vue
// module id = null
// module chunks = 